function directoryFilterSort() {
    const url = new URL(window.location.href);
    const searchParams = url.searchParams;

    const getArrayParam = (paramBaseName) =>
        Array.from(searchParams.entries())
            .filter(([key]) => key.startsWith(`${paramBaseName}[`))
            .map(([, value]) => decodeURIComponent(value));

    const sortOptionsMap = {
        'Distance from City Center': ['distance', '0', 'distance'],
        'Highest Rating': ['review_score', '1', 'rating'],
        'Name A - Z': ['name', '0', 'a-z'],
        'Name Z - A': ['name', '1', 'z-a'],
    };

    const filterOptionsMap = {
        cities: 'top_city_ids',
        categories: 'category_ids',
    };

    const resetPagination = (pathname) => pathname.replace(/\/page\/\d+\//, '');

    const clearFilterParams = () => {
        let filtersCleared = false;
        [...searchParams.keys()].forEach((key) => {
            if (key.startsWith('category_ids') || key.startsWith('top_city_ids')) {
                searchParams.delete(key);
                filtersCleared = true;
            }
        });
        return filtersCleared;
    };

    const getSelectedFiltersWithNames = (selector) =>
        Array.from(document.querySelectorAll(selector)).map((checkbox) => {
            const name = checkbox.closest('li').textContent.trim();
            return { id: checkbox.value, name };
        });

    const updateUrlAndReload = (basePath) => {
        const queryString = searchParams.toString();
        window.location.href = queryString ? `${window.location.origin}${basePath}?${queryString}` : `${window.location.origin}${basePath}`;
    };

    const sendGA4Event = (eventName, eventData) => {
        if (window.dataLayer) {
            const ga4Event = {
                event: eventName,
                ...eventData,
            };

            window.dataLayer.push(ga4Event);
            console.log(ga4Event);
        }
    };

    const initializeActiveOptions = (list, isFilter) => { // Removed selectedText parameter
        if (!isFilter) {
            const sortBy = searchParams.get('sort_by') || 'distance';
            const sortDesc = searchParams.get('sort_desc') || '0';

            list.querySelectorAll('.sort-list').forEach((item) => {
                const [mappedSortBy, mappedSortDesc] = sortOptionsMap[item.dataset.value] || [];
                if (mappedSortBy === sortBy && mappedSortDesc === sortDesc) {
                    item.classList.add('active');
                }
            });

            const activeItem = list.querySelector('.sort-list.active');
            if (!activeItem) {
                const defaultItem = list.querySelector('[data-value="Distance from City Center"]');
                if (defaultItem) {
                    defaultItem.classList.add('active');
                }
            }
        } else {
            Object.values(filterOptionsMap).forEach((paramName) => {
                const selectedValues = getArrayParam(paramName);
                list.querySelectorAll(`input[name="${paramName}[]"]`).forEach((checkbox) => {
                    checkbox.checked = selectedValues.includes(checkbox.value);
                    checkbox.closest('li').classList.toggle('active', checkbox.checked);
                });
            });
        }
    };

    function updateFilterIndicator() {
        const filterButton = document.querySelector('.dropdown-button.filter');
        if (!filterButton) return;

        const cityFilters = document.querySelectorAll('.cities input:checked').length;
        const categoryFilters = document.querySelectorAll('.list-categories input:checked').length;
        const totalFilters = cityFilters + categoryFilters;

        let indicator = filterButton.querySelector('.filter-indicator');

        if (totalFilters > 0) {
            if (!indicator) {
                indicator = document.createElement('span');
                indicator.className = 'filter-indicator';
                filterButton.prepend(indicator);
            }
            indicator.textContent = totalFilters;
            indicator.style.display = 'inline-flex';
            filterButton.classList.add('filters-applied');
        } else {
            indicator?.remove();
            filterButton.classList.remove('filters-applied');
        }
    }

    const dropdowns = [
        // Removed selectedText from this object
        { button: document.querySelector('.dropdown-button.sort'), list: document.querySelector('.dropdown-list.sort'), isFilter: false },
        { button: document.querySelector('.dropdown-button.filter'), list: document.querySelector('.dropdown-list.filter'), isFilter: true },
    ];

    const closeAllDropdowns = () => dropdowns.forEach(({ button, list }) => {
        button?.classList.remove('active');
        list?.classList.remove('show');
    });

    const toggleDropdown = (button, list) => {
        closeAllDropdowns();
        button.classList.toggle('active');
        list.classList.toggle('show');
    };

    // Removed selectedText from the destructuring in the forEach loop
    dropdowns.forEach(({ button, list, isFilter }) => {
        if (!list || !button) return;

        // Removed selectedText from the initializeActiveOptions call
        initializeActiveOptions(list, isFilter);
        const applyFilterButton = list.querySelector('#apply-filters');
        const clearFiltersButton = list.querySelector('#clear-filters');

        button.addEventListener('click', (event) => {
            event.stopPropagation();
            toggleDropdown(button, list);
        });

        list.querySelectorAll('li.sort-list').forEach((item) =>
            item.addEventListener('click', () => {
                list.querySelector('.active')?.classList.remove('active');
                item.classList.add('active');
                // Removed selectedText.textContent update
                list.classList.remove('show');
                button.classList.remove('active');

                const sortParams = sortOptionsMap[item.dataset.value] || ['distance', '0', 'distance'];
                const [sortBy, sortDesc, gtmKey] = sortParams;

                searchParams.set('sort_by', sortBy);
                searchParams.set('sort_desc', sortDesc);

                sendGA4Event('directory_sorting', {
                    pageUrl: window.location.href,
                    sortBy: gtmKey,
                });

                updateUrlAndReload(resetPagination(url.pathname));
            })
        );

        if (isFilter && (applyFilterButton || clearFiltersButton)) {
            const basePath = resetPagination(url.pathname);

            applyFilterButton?.addEventListener('click', () => {
                clearFilterParams();
                const cityFilters = getSelectedFiltersWithNames('.cities input:checked');
                const categoryFilters = getSelectedFiltersWithNames('.list-categories input:checked');

                cityFilters.forEach((filter, index) => searchParams.append(`top_city_ids[${index}]`, filter.id));
                categoryFilters.forEach((filter, index) => searchParams.append(`category_ids[${index}]`, filter.id));

                sendGA4Event('directory_filtering', {
                    pageUrl: window.location.href,
                    filterAction: 'applied',
                    filterValue: {
                        cities: cityFilters.map((filter) => filter.name),
                        categories: categoryFilters.map((filter) => filter.name),
                    },
                });

                updateUrlAndReload(basePath);
            });

            clearFiltersButton?.addEventListener('click', () => {
                document.querySelectorAll('.cities input:checked, .list-categories input:checked').forEach(checkbox => {
                    checkbox.checked = false;
                    checkbox.closest('li')?.classList.remove('active');
                });

                const filtersCleared = clearFilterParams();

                const hasSelections = document.querySelectorAll('.cities input:checked, .list-categories input:checked').length > 0;
                if (filtersCleared || hasSelections) {
                    sendGA4Event('directory_filtering', {
                        pageUrl: window.location.href,
                        filterAction: 'cleared',
                        filterValue: null,
                    });

                    updateUrlAndReload(basePath);
                }

                updateFilterIndicator();
            });
        }
    });

    document.querySelectorAll('.cities input, .list-categories input').forEach((checkbox) => {
        checkbox.addEventListener('change', updateFilterIndicator);
    });

    updateFilterIndicator();

    document.addEventListener('click', (event) => {
        if (!dropdowns.some(({ button, list }) => button.contains(event.target) || list.contains(event.target))) {
            closeAllDropdowns();
        }
    });
}

export default function init() {
    directoryFilterSort();
}